import { ProductApiItem } from '../product-api/product-api-item';
import { AverageRating, ProductAttribute, TechnicalSpecification } from '../product-api/product-attribute';

export type PartialProductListItem = {
  ean: string;
  name: string;
  price: number;
  imgPaths?: string[];
  brand?: string;
};

export class ProductListItem {
  id: string;
  ean: string;
  name: string;
  description: string;
  featureSummary: string;
  technicalSpecifications: TechnicalSpecification[];
  averageRating: AverageRating;
  infoBullets: string[];
  brand: string;
  price: number;
  imgPaths: string[];
  bundleBillOfMaterials: ProductAttribute[];
  bundleProducts?: ProductListItem[];
  categoryIds: string[] = [];

  /** Construit un produit à partir des seules données conservées dans une configuration enregistrée. */
  static fromPartial(partial: PartialProductListItem): ProductListItem {
    const product = new ProductListItem();
    product.ean = partial.ean;
    product.name = partial.name;
    product.price = partial.price;
    product.imgPaths = partial.imgPaths ?? [];
    product.brand = partial.brand;
    return product;
  }

  constructor(input?: ProductApiItem) {
    if (!input) {
      this.imgPaths = [];
      return;
    }

    this.id = input.id;
    this.ean = input.attributes.ean;
    this.name = input.attributes.name;
    this.description = input.attributes.description;
    this.featureSummary = input.attributes.featureSummary;
    this.infoBullets = input.attributes.infoBullets;
    this.technicalSpecifications = input.attributes.technicalSpecifications;
    this.averageRating = input.attributes.averageRating;
    this.price = input.attributes.pricing.currentPrice.amountIncTax;
    this.imgPaths = [];
    let index = 0;
    input.attributes.mediaObjects
      .filter(m => m.url.includes('image'))
      .forEach(u => {
        this.imgPaths[index] = u.url.replace('{width}', '300').replace('{height}', '300');
        index++;
      });
    this.bundleBillOfMaterials = input.attributes.bundleBillOfMaterials;
    this.categoryIds = input.attributes.categoryIds ?? [];
    if (input.attributes?.technicalSpecifications?.filter(ts => ts.name === 'Marque').length > 0)
      this.brand = input.attributes?.technicalSpecifications?.filter(ts => ts.name === 'Marque')[0].value;
    else if (input.attributes?.technicalSpecifications?.filter(ts => ts.name === 'Gamme').length > 0)
      this.brand = input.attributes?.technicalSpecifications?.filter(ts => ts.name === 'Gamme')[0].value;
  }
}
